import { PayloadAction } from '../../../store.model';
import { ActionType } from '../search.action';
import { SearchState } from '../search.state';

import { SelectUser } from './select-user.action';

export function selectUserReducer(
    state: SearchState,
    action: PayloadAction<ActionType.EVAL_SEARCH__SELECT_USER, SelectUser>,
): SearchState {
    return {
        ...state,
        selectedUser: {
            value: action.payload.user,
            initialLoad: false,
        },
    };
}
